import React from 'react';
import CountUp from 'react-countup';

const Counter = () => {
    return (
        <section className="tf-section counter">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="counter__body" data-aos="fade-down" data-aos-duration="1000">
                            <div className="counter">
                                <div className="number-counter">
                                    <CountUp end={21} />
                                </div>
                                <h5 className="title">Years in business</h5>    
                            </div>
                            <div className="counter">
                                <div className="number-counter">
                                <CountUp end={1200} />
                                </div>
                                <h5 className="title">Clients Served</h5>    
                            </div>
                            <div className="counter">
                                <div className="number-counter">
                                <CountUp end={10} />
                                </div>
                                <h5 className="title">client consecutive years</h5>    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Counter;